export default "__VITE_ASSET__97b0725c__"